import { fetch } from '../utils/request';

const getUrl = (path) => `${process.env.MONO_API}${path}`;

/**
 * Fetch a paginated list of TrackingLinks for the current account.
 * @param {Object} [query] - Optional query params to add to URL.
 * @returns {Promise<Object>} API Response.
 */
export function getTrackingLinks(query = {}) {
  return fetch(getUrl('/tracking-links'), { query });
}

/**
 * Fetch a single TrackingLink by its rid.
 * @param {string} rid - TrackingLink rid to fetch.
 * @returns {Promise<Object>} API Response.
 */
export function getTrackingLinkByRid(rid) {
  return fetch(getUrl(`/tracking-links/by-rid/${rid}`));
}

/**
 * Create a TrackingLinkMetadata record. Idempotent by rid, so it's safe to
 * retry while Producer syncs metadata for a timeline item.
 * @param {Object} data - Metadata fields.
 * @returns {Promise<Object>} API Response.
 */
export function createTrackingLinkMetadata(data) {
  return fetch(getUrl('/tracking-link-metadata'), {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(data),
  });
}

/**
 * Fetch a single TrackingLinkMetadata record by rid.
 * @param {string} rid - Metadata rid to fetch.
 * @returns {Promise<Object>} API Response.
 */
export function getTrackingLinkMetadataByRid(rid) {
  return fetch(getUrl(`/tracking-link-metadata/by-rid/${rid}`));
}

/**
 * Ensure the static `shoppable` TrackingLink for a saved product. Called when a
 * product is first dropped into a graphic so links are only created for
 * products that are actually used, and reused for later occurrences.
 * @param {number} productId - ID of the saved Product.
 * @returns {Promise<Object>} `{ trackingLinkId, trackingLinkRid, trackingLink }`.
 */
export function ensureShoppableTrackingLink(productId) {
  return fetch(getUrl('/products/tracking-link'), {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ productId }),
  });
}
